import { transformEventItems } from "$lib/utilities/calendar";
import { groupEventsByDay } from "$lib/utilities/eventSchedule";
import { toChicagoDate } from "../eventDate";

export let resizeParams = {};

export const EPL_FORM_FACTORS = {
  GRID: "Calendar Grid",
  LIST: "Calendar List",
  SCHEDULE: "Event Schedule"
};

export const getThemedItemIds = (themeObject) => {
  if (themeObject) {
    return themeObject.map((themedItem) => {
      return themedItem.sys?.id;
    });
  }
  return [];
};

/**
 * Removes excluded and featured items from the main list and filters events with out-of-range dates
 *
 * @param {*} items
 * @param {*} featuredItems
 * @param {*} excludedItems
 * @param {*} startDate
 * @param {*} endDate
 * @returns
 */
export const filterListItems = ({
  items,
  featuredItems = [],
  excludedItems = [],
  startDate,
  endDate,
  todaysDate
}) => {
  return items.filter(
    (item) =>
      !excludedItems.some((excluded) => excluded.sys?.id === item.sys?.id) &&
      !featuredItems.some((featured) => featured.sys?.id === item.sys?.id) &&
      !(startDate && new Date(item.fields.start) < new Date(startDate)) &&
      !(endDate && new Date(item.fields.start) > new Date(endDate)) &&
      !(new Date(item.fields.end || item.fields.start) < toChicagoDate(todaysDate))
  );
};

export const transformListItems = ({
  items = [],
  themedItems = [],
  featuredItems = [],
  excludedItems = [],
  maxItems,
  startDate,
  endDate,
  showMonth,
  formFactor,
  todaysDate
}) => {
  // Limit to 1 featured item
  const featuredEvents = featuredItems.map((item) => item.fields).slice(0, 1);
  const featuredColumnCount = featuredEvents.length * 2;
  const filteredEvents = filterListItems({
    items,
    featuredItems,
    excludedItems,
    startDate,
    endDate,
    todaysDate
  });

  // Account for 2 columns if featured item exists. No maxItems limit for schedule view.
  const events = filteredEvents
    .slice(
      0,
      formFactor === EPL_FORM_FACTORS.SCHEDULE || !maxItems
        ? undefined
        : maxItems - featuredColumnCount
    )
    .map((item) => {
      return { ...item.fields, contentType: item.sys?.contentType?.sys?.id } || {};
    })
    .sort((a, b) => new Date(a.start) - new Date(b.start));

  return {
    days: groupEventsByDay([...events, ...featuredEvents]),
    items: transformEventItems({ items: events, themedItems, showMonth, formFactor }),
    featuredItems: transformEventItems({ items: featuredEvents, formFactor })
  };
};
